import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Epaper from "../views/Epaper.vue";


Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/epaper/:id",
    name: "Epaper",
    component: Epaper,
  },
  {
    path: "/about",
    name: "About",
    component: () => 
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => 
      import(/* webpackChunkName: "contact" */ "../views/About.vue"),
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () => 
      import(/* webpackChunkName: "privacy" */ "../views/About.vue"),
  },
  {
    path: "*",
    name: "Missing",
    component: () => 
      import(/* webpackChunkName: "error" */ "../views/404.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
